import { Image } from "antd";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import entete from "../../../../assets/img/entete.jpg";
import { frenchMonth } from "../../../../variables/functions";
import { displayNumbers } from "../../../../variables/numbersFunctions";
import { DocumentFooter } from "../../../../components/docs/DocumentFooter";
import DocumentHeader from "../../../../components/docs/DocumentHeader";
import axiosInstance from "../../../../variables/api/axiosInstance";

const CompteDeCessionParCategorieParCompagnie = React.forwardRef((props, ref) => {
    // Informations ACTUALISÉES de la compagnie (organisme) — le `compagnie` transmis peut être une
    // version périmée (raison sociale/adresse/téléphone d'une ancienne version historisée). On récupère
    // l'organisme actif par son code pour afficher l'adresse (siège social) et le téléphone à jour.
    const [orgInfo, setOrgInfo] = useState(props?.compagnie || {});
    useEffect(() => {
        const code = props?.compagnie?.code;
        const nom = props?.compagnie?.raisonSociale;
        if (code) {
            axiosInstance.get(`/api/organisme/code/${code}`)
                .then(({ data }) => { if (data) setOrgInfo(data); })
                .catch((err) => console.log(err));
            return;
        }
        // Certains écrans (listes SQL des cessions) ne transmettent que la raison sociale :
        // on retrouve alors la compagnie par son nom parmi les organismes d'assurance.
        if (!nom) return;
        const norm = (s) => (s || "").trim().toLowerCase();
        axiosInstance.get(`/api/organisme/assurance`)
            .then(({ data }) => {
                const org = (Array.isArray(data) ? data : []).find((o) => norm(o?.raisonSociale) === norm(nom));
                if (org) setOrgInfo(org);
            })
            .catch((err) => console.log(err));
    }, [props?.compagnie?.code, props?.compagnie?.raisonSociale]);

    const montantSouscriptions = props?.totals ? props?.totals?.totalEmissions : props?.souscriptions ? props?.souscriptions?.reduce((sum, reglement) => reglement.data.montant > 0 ? sum + reglement.data.montant : sum, 0) : 0;
    const montantAnnulations = props?.totals ? props?.totals?.totalAnnulations : props?.souscriptions ? props?.souscriptions?.reduce((sum, reglement) => reglement.data.montant < 0 ? sum + reglement.data.montant : sum, 0) : 0;
    const montantSinistresPayes = props?.totals ? props?.totals?.totalSinistres : props?.sinistres ? props?.sinistres?.reduce((sum, sinistre) => sum + sinistre.montant, 0) : 0;
    const montantRecoursSinistres = props?.totals ? props?.totals?.totalRecours : props?.sinistres ? props?.sinistres?.reduce((sum, sinistre) => sinistre.recours ? sum + sinistre.montant : sum, 0) : 0;
    const indemniteDeGestion = props?.totals ? props?.totals?.indemnitesEmissions : montantSouscriptions * 0.15;
    const indemniteDeGestionAnnulations = props?.totals ? props?.totals?.indemnitesAnnulations : montantAnnulations * 0.15;
    const difference = props?.totals ? props?.totals?.debit - props?.totals?.credit : (montantSouscriptions + Math.abs(montantAnnulations)) - (indemniteDeGestion + Math.abs(indemniteDeGestionAnnulations) + montantSinistresPayes + montantRecoursSinistres);

    return (
        <div className="col-12 ccc-compte-cession"
            style={{
                width: "210mm",
                height: "297mm",
                margin: 0,
                padding: 0,
                pageBreakInside: "avoid",
                fontFamily: "'Times New Roman', Times, serif"
            }}
            ref={ref}
        >
            {/* Traits du tableau plus épais et NOIRS → lisibles à l'impression (les bordures Bootstrap
                par défaut, gris clair 1px, s'impriment à peine). Scopé à ce document uniquement. */}
            <style>{`
                .ccc-compte-cession .table-bordered { border-collapse: collapse !important; }
                .ccc-compte-cession .table-bordered,
                .ccc-compte-cession .table-bordered th,
                .ccc-compte-cession .table-bordered td { border: 1.5px solid #000 !important; }
                @media print {
                    .ccc-compte-cession .table-bordered,
                    .ccc-compte-cession .table-bordered th,
                    .ccc-compte-cession .table-bordered td {
                        border: 2px solid #000 !important;
                        -webkit-print-color-adjust: exact; print-color-adjust: exact;
                    }
                }
            `}</style>
            <div className="card" style={{
                display: "flex",
                flexDirection: "column",
                minHeight: "297mm",
                position: "relative"
            }}>
                <DocumentHeader typeOrganisme={"ASSURANCE"} logoPreviewUrl={props?.logoPreviewUrl} />

                <div
                    className=""
                    style={{
                        padding: "5mm",
                        boxSizing: "border-box",
                        flex: "1"
                    }}
                >
                    <div className="">
                        <div className="row">
                            <div className="col-12">
                                <table
                                    className="table table-bordered"
                                    style={{ width: "40%" }}
                                >
                                    <tbody>
                                        <tr style={{ lineHeight: "1" }}>
                                            <td className="text-left">
                                                <strong>COMPTE DE CESSION</strong>
                                            </td>
                                        </tr>
                                        <tr style={{ lineHeight: "1" }}>
                                            <td className="text-left">
                                                <strong>Catégorie: {props?.categorie?.codeCategorie === "M" ? "MOTO" : "TPV"}</strong>
                                            </td>
                                        </tr>
                                        <tr style={{ lineHeight: "1" }}>
                                            <td className="text-left">
                                                <em><strong>Période: {frenchMonth(props?.periode?.split("-")?.[1])} {props?.periode?.split("-")?.[0]}</strong></em>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <br />
                        <div style={{ marginLeft: "360px" }}>
                            <p style={{ fontWeight: "bold" }}><strong>{orgInfo?.raisonSociale || props?.compagnie?.raisonSociale}</strong></p>
                            <p style={{ fontWeight: "bold" }}><strong>{orgInfo?.siegeSocial || props?.compagnie?.siegeSocial}</strong></p>
                            {/* Téléphone : telephone1, sinon 1er contact (même repli que la fiche membre, EditMembreModal). */}
                            <p style={{ fontWeight: "bold" }}><strong>Tel: {orgInfo?.telephone1 || orgInfo?.contact?.[0] || ""}{orgInfo?.telephone2 ? ` / ${orgInfo.telephone2}` : ""}</strong></p>
                            <p style={{ fontWeight: "bold" }}><strong>LOME</strong></p>
                        </div>

                        <br />

                        <div className="row">
                            <div className="col-12">
                                <table
                                    className="table table-bordered"
                                    style={{ width: "100%" }}
                                >
                                    <thead>
                                        <tr style={{ lineHeight: "1" }}>
                                            <th>Postes</th>
                                            <th className="text-center">Débit</th>
                                            <th className="text-center">Crédit</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style={{ lineHeight: "1" }}>
                                            <td className="text-start">
                                                MONTANT TOTAL DES SOUSCRIPTIONS
                                            </td>
                                            <td className="text-end"></td>
                                            <td className="text-end">
                                                {displayNumbers(props?.totals?.totalEmissions)}
                                            </td>
                                        </tr>
                                        {props?.totals?.totalAnnulations > 0 && <tr style={{ lineHeight: "1" }}>
                                            <td className="text-start">
                                                ANNULATIONS ET RISTOURNES
                                            </td>
                                            <td className="text-end">
                                                {displayNumbers(Math.abs(props?.totals?.totalAnnulations))}
                                            </td>
                                            <td className="text-end">
                                            </td>
                                        </tr>}
                                        <tr style={{ lineHeight: "1" }}>
                                            <td className="text-start">
                                                INDEMNITE DE GESTION (15%)
                                            </td>
                                            <td className="text-end">
                                                {displayNumbers(props?.totals?.indemnitesEmissions)}
                                            </td>
                                            <td className="text-end">
                                            </td>
                                        </tr>
                                        {props?.totals?.indemnitesAnnulations > 0 && <tr style={{ lineHeight: "1" }}>
                                            <td className="text-start">
                                                INDEMNITE DE GESTION SUR ANNULATION (15%)
                                            </td>
                                            <td className="text-end">
                                            </td>
                                            <td className="text-end">
                                                {displayNumbers(Math.abs(props?.totals?.indemnitesAnnulations))}
                                            </td>
                                        </tr>}
                                        <tr style={{ lineHeight: "1" }}>
                                            <td className="text-start">
                                                SINISTRES PAYES
                                            </td>
                                            <td className="text-end">{displayNumbers(props?.totals?.totalSinistres)}</td>
                                            <td className="text-end"></td>
                                        </tr>
                                        {props?.totals?.totalRecours > 0 && <tr style={{ lineHeight: "1" }}>
                                            <td className="text-start">
                                                RECOURS ENCAISSES
                                            </td>
                                            <td className="text-end">
                                            </td>
                                            <td className="text-end">
                                                {displayNumbers(props?.totals?.totalRecours)}
                                            </td>
                                        </tr>}
                                        <tr style={{ lineHeight: "1" }}>
                                            <td className="text-start">
                                                <strong>SOLDE EN FAVEUR {props?.totals.soldeEnFaveurDe}</strong>
                                            </td>
                                            <td className="text-end">{props?.totals?.solde < 0 ? displayNumbers(props?.totals?.soldeMontant) : ""}</td>
                                            <td className="text-end">{props?.totals?.solde > 0 ? displayNumbers(props?.totals?.soldeMontant) : ""}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr style={{ lineHeight: "1" }}>
                                            <th>BALANCE</th>
                                            <th className="text-end">{displayNumbers(difference >= 0 ? props?.totals?.debit : props?.totals?.credit)}</th>
                                            <th className="text-end">{displayNumbers(difference >= 0 ? props?.totals?.debit : props?.totals?.credit)}</th>
                                        </tr>
                                    </tfoot>
                                </table>
                                <br />
                                <div style={{ marginLeft: "500px" }}>
                                    <div className="row">
                                        <div className="col-12">
                                            <u><strong>Pour la société</strong></u>
                                        </div>
                                        <div className="col-12" style={{ marginTop: "45px" }}>
                                            <div style={{ marginBottom: "8px" }}>Cachet et Signature</div>
                                            <div style={{ borderTop: "1px solid #000", paddingTop: "4px", minWidth: "220px" }}>
                                                <strong>{orgInfo?.raisonSociale || props?.compagnie?.raisonSociale || ""}</strong>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <DocumentFooter
                    style={{
                        width: "100%",
                        marginTop: "auto"
                    }}
                />
            </div>
        </div>
    );
});

CompteDeCessionParCategorieParCompagnie.propTypes = {
    souscriptions: PropTypes.array,
    sinistres: PropTypes.array,
    categorie: PropTypes.object,
    compagnie: PropTypes.object,
    periode: PropTypes.string,
    totals: PropTypes.object
};
export default CompteDeCessionParCategorieParCompagnie;
